import HiDocumentGuard from "./HiDocumentGuard";
import { lazy } from "react";
import { R_HiRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const HiDetailsPage = lazy(() => import("./HiDetailsPage/HiDetailsPage"));
const MedicalReports = lazy(() => import("./MedicalReports/MedicalReports"));
const HiEditPolicy = lazy(() => import("./HiEditPolicy/HiEditPolicy"));
const HiPolicyDocuments = lazy(
  () => import("./HiDetailsPage/HiPolicyDocuments/HiPolicyDocuments"),
);

const HealthInsuranceRoutesFn = () => {
  return [
    {
      path: R_HiRoutes.hi_baseUrl,
      element: <HiDocumentGuard />,
      children: [
        {
          path: R_HiRoutes.details_PolicyNumber,
          element: <SuspenseWrapper LazyLoadingComponent={HiDetailsPage} />,
        },
        {
          path: `${R_HiRoutes.details_PolicyNumber_MedicalReports}`,
          element: <SuspenseWrapper LazyLoadingComponent={MedicalReports} />,
        },
        {
          path: `${R_HiRoutes.details_PolicyNumber_EditPolicy}`,
          element: <SuspenseWrapper LazyLoadingComponent={HiEditPolicy} />,
        },
        {
          path: `${R_HiRoutes.details_PolicyNumber_PolicyDocuments}`,
          element: <SuspenseWrapper LazyLoadingComponent={HiPolicyDocuments} />,
        },
      ],
    },
    {
      path: R_HiRoutes.edit_hi_policy_details,
      element: <SuspenseWrapper LazyLoadingComponent={HiEditPolicy} />,
    },
  ];
};
export { HealthInsuranceRoutesFn };
